import { render, staticRenderFns } from "./topExposurePnLReport.vue?vue&type=template&id=ec52e73c&scoped=true&"
import script from "./topExposurePnLReport.vue?vue&type=script&lang=js&"
export * from "./topExposurePnLReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec52e73c",
  null
  
)

export default component.exports